// @TODO: redevelop this component
// @flow
import React, {useState, useEffect, useRef} from "react";
import {useObserver} from "mobx-react-lite";
import {Col, Select, Spin, message, Checkbox} from "antd";
import {useStore} from "../../../hooks/useStore";
import {useFetch} from "../../../hooks/useFetch";
import {SpaceField, CustomSelect, SelectTitle, SlotCourierTitle} from "./multipleSelectStyles";
import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {groupBy} from "lodash";
import {useTranslation} from "react-i18next";

const {Option, OptGroup} = Select;

export const MultipleSelect = ({direction, list, data, onChange, disabled, hideTitle}) => {
    const stores = useStore();
    const {t} = useTranslation(["multipleSelect"]);

    const [cityValue, setCityValue] = useState(data?.city);
    const [companyValue, setCompanyValue] = useState(data?.dedicatedCompanyId || "");
    const [regionGroupValue, setRegionGroupValue] = useState(
        data?.regionGroups && data?.regionGroups.length > 0 ? data.regionGroups : ["all"]
    );
    const [deliveryPointRegionGroupsValues, setDeliveryPointRegionGroupsValues] = useState(
        data?.deliveryPointRegionGroups && data?.deliveryPointRegionGroups.length > 0
            ? data.deliveryPointRegionGroups
            : ["all"]
    );
    const [subCompanyValue, setSubCompanyValue] = useState(data?.dedicatedSubCompanies || ["all"]);
    const [slotCourierValue, setSlotCourierValue] = useState(data?.slotCourier);

    const [cityRecall, setCityRecall] = useState(false);
    const [companyRecall, setCompanyRecall] = useState(false);
    const [regionGroupRecall, setregionGroupRecall] = useState(false);
    const [
        deliveryPointRegionGroupsValuesRecall,
        setDeliveryPointRegionGroupsValuesRecall
    ] = useState(false);
    const [subCompanyRecall, setSubCompanyRecall] = useState(false);

    const [isCompanyChanged, setIsCompanyChanged] = useState(false);
    const [isRegionChanged, setIsRegionChanged] = useState(false);
    const [isDeliveryPointReqionGroupChange, setDeliveryPointReqionGroupChange] = useState(false);
    const [isSubCompanyChanged, setIsSubCompanyChanged] = useState(false);
    const [isSlotCourierChanged, setIsSlotCourierChanged] = useState(false);

    const cityRecallRef = useRef(cityRecall);
    const companyRecallRef = useRef(companyRecall);
    const regionGroupRecallRef = useRef(regionGroupRecall);
    const deliveryPointRegionGroupsValuesRecallRef = useRef(deliveryPointRegionGroupsValuesRecall);
    const subCompanyRecallRef = useRef(subCompanyRecall);

    cityRecallRef.current = cityRecall;
    companyRecallRef.current = companyRecall;
    regionGroupRecallRef.current = regionGroupRecall;
    deliveryPointRegionGroupsValuesRecallRef.current = deliveryPointRegionGroupsValuesRecall;
    subCompanyRecallRef.current = subCompanyRecall;

    const [cityLoading, cityData, setCityData, setCityLoading] =
        list.filter(obj => obj.key === "city").length > 0
            ? useFetch({
                  defaultDataValue: {},
                  fetchFn: stores.courierStore.getMultipleSelectCities.bind(null, {
                      limit: 1000,
                      offset: 0,
                      city: cityValue,
                      companyId: companyValue,
                      regions: []
                  }),
                  dependencies: [cityRecall]
              })
            : [false, [], () => {}, () => {}];

    const [companyLoading, companyData, setCompanyData, setCompanyLoading] = useFetch({
        defaultDataValue: {},
        fetchFn: stores.courierStore.getMultipleSelectCompanies.bind(null, {
            limit: 1000,
            offset: 0,
            city: cityValue,
            companyId: companyValue
        }),
        dependencies: [companyRecall]
    });

    const [subCompanyLoading, subCompanyData, setSubCompanyData, setSubCompanyLoading] = useFetch({
        defaultDataValue: {},
        fetchFn: stores.courierStore.getSubCompaniesByRegionGroup.bind(null, {
            limit: 1000,
            offset: 0,
            city: data?.city,
            companyId: companyValue,
            regionGroups: regionGroupValue,
            disabled: "all"
        }),
        dependencies: [subCompanyRecall]
    });

    const [
        regionGroupLoading,
        regionGroupData,
        setregionGroupData,
        setRegionGroupLoading
    ] = useFetch({
        defaultDataValue: {},
        fetchFn: stores.courierStore.getMultipleSelectRegionGroups.bind(null, {
            limit: 1000,
            offset: 0,
            companyId: companyValue ? companyValue : /* "pool" Open when pool is ready */ undefined
        }),
        dependencies: [subCompanyRecall]
    });

    const onCityChange = value => {
        setCityValue(value);
    };

    const onCompanyChange = value => {
        companyValue !== value && setIsCompanyChanged(true);
        setCompanyValue(value);
        setSubCompanyValue(["all"]);
        setSubCompanyRecall(!subCompanyRecallRef.current);
        setRegionGroupValue(["all"]);
        setregionGroupRecall(regionGroupRecallRef.current);
        setDeliveryPointRegionGroupsValues(["all"]);
        setDeliveryPointRegionGroupsValuesRecall(regionGroupRecallRef.current);
    };

    const onRegionGroupChange = value => {
        regionGroupValue !== value && setIsRegionChanged(true);
        setSubCompanyValue(["all"]);
        if (value[value.length - 1] === "all" || value.length === 0) {
            setRegionGroupValue(["all"]);
        } else {
            const index = value.indexOf("all");
            index > -1 && value.splice(index, 1);
            setRegionGroupValue(value);
        }
        setSubCompanyRecall(!subCompanyRecallRef.current);
    };

    const onDeliveryPointReqionGroupChange = value => {
        deliveryPointRegionGroupsValues !== value && setDeliveryPointReqionGroupChange(true);
        if (value[value.length - 1] === "all" || value.length === 0) {
            setDeliveryPointRegionGroupsValues(["all"]);
        } else {
            const index = value.indexOf("all");
            index > -1 && value.splice(index, 1);
            setDeliveryPointRegionGroupsValues(value);
        }
    };

    const onSubCompanyChange = value => {
        subCompanyValue !== value && setIsSubCompanyChanged(true);
        if (value[value.length - 1] === "all") {
            setSubCompanyValue(["all"]);
        } else {
            const index = value.indexOf("all");
            index > -1 && value.splice(index, 1);
            setSubCompanyValue(value);
        }
    };

    useEffect(() => {
        if (
            [
                isSubCompanyChanged,
                isCompanyChanged,
                isRegionChanged,
                isDeliveryPointReqionGroupChange,
                isSlotCourierChanged
            ].some(i => i)
        ) {
            onChange({
                city: cityValue,
                companyId: companyValue,
                regionGroups: regionGroupValue,
                deliveryPointRegionGroups: deliveryPointRegionGroupsValues,
                subCompanies: subCompanyValue,
                courierId: data?._id,
                slotCourier: slotCourierValue
            });
        }
    }, [
        cityValue,
        companyValue,
        regionGroupValue,
        deliveryPointRegionGroupsValues,
        subCompanyValue,
        slotCourierValue
    ]);

    const checkDifferentRegionGroup = group => {
        const firstSelectedRegion =
            regionGroupData &&
            regionGroupData.filter(regionGroup => regionGroup._id === regionGroupValue[0]);
        const firstSelectedGroup = firstSelectedRegion?.[0]?.group;
        if (firstSelectedGroup === undefined) {
            return false;
        } else {
            return firstSelectedGroup !== group;
        }
    };

    const renderRegionGroupsByGrouping = (regionGroups, key) => {
        const groupByRegion = groupBy(regionGroups, "group");
        const keyOfUpperGroup = Object.keys(groupByRegion);
        let groupedRegions;
        if (groupByRegion && regionGroups != ["all"]) {
            groupedRegions = keyOfUpperGroup.map((upperGroup, i) => (
                <OptGroup
                    label={upperGroup}
                    key={i}
                    data-testid={`${key}Select_optionGroup`}
                    data-testvalue={upperGroup}
                >
                    {arrayAlphabeticalSort(groupByRegion[upperGroup]).map(regionGroup => (
                        <Option
                            key={regionGroup._id}
                            value={regionGroup._id}
                            data-testid={`${key}Select_optionGroup`}
                            disabled={checkDifferentRegionGroup(regionGroup.group)}
                        >
                            {regionGroup.name}
                        </Option>
                    ))}
                </OptGroup>
            ));
        }
        return groupedRegions;
    };

    const filterSort = (optionA, optionB) =>
        optionA.children &&
        optionA.children
            .toString()
            .toLowerCase()
            .localeCompare(optionB.children.toString().toLowerCase());

    const filterOption = (input, option) =>
        option.children &&
        option.children
            .toString()
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0;

    const renderOptionLoading = key => (
        <Option key="loading" value="loading" data-testid={`${key}Select_option`}>
            <Spin size="small" spinning></Spin>
        </Option>
    );

    const renderAllOption = key => (
        <Option key="all" value="all" data-testid={`${key}Select_option`}>
            {t("filters.all", {ns: "common"})} {"                 "}
        </Option>
    );

    return useObserver(() => (
        <SpaceField direction={direction} style={{width: "100%"}}>
            {list.map((obj, i) => (
                <React.Fragment key={i}>
                    {obj.key === "city" && (
                        <Col>
                            {!hideTitle && (
                                <SelectTitle>{t("fields.city", {ns: "common"})}</SelectTitle>
                            )}
                            <CustomSelect
                                style={{width: obj.width}}
                                value={cityValue}
                                onChange={onCityChange}
                                notFoundContent={t("filters.notEnoughData", {ns: "common"})}
                                maxTagCount={2}
                                loading={cityLoading}
                                disabled={cityLoading || disabled}
                                data-testid={`${obj.key}Select`}
                            >
                                {cityLoading ? (
                                    renderOptionLoading(obj.key)
                                ) : (
                                    <Option>{data.city}</Option>
                                )}
                            </CustomSelect>
                        </Col>
                    )}
                    {obj.key == "company" && (
                        <Col>
                            {!hideTitle && (
                                <SelectTitle>{t("fields.company", {ns: "common"})}</SelectTitle>
                            )}
                            <CustomSelect
                                showSearch
                                style={{width: obj.width}}
                                value={companyValue}
                                onChange={onCompanyChange}
                                notFoundContent={t("filters.notEnoughData", {ns: "common"})}
                                loading={companyLoading}
                                disabled={companyLoading || disabled}
                                data-testid={`${obj.key}Select`}
                                optionFilterProp="children"
                            >
                                {companyLoading ? (
                                    renderOptionLoading(obj.key)
                                ) : (
                                    <>
                                        <CustomSelect.Option
                                            value=""
                                            data-testid={`${obj.key}Select_option`}
                                        >
                                            {t("poolCourier", {ns: "multipleSelect"})}
                                        </CustomSelect.Option>
                                        {stores.appStore.companyListFilter
                                            .filter(company => {
                                                if (companyValue === company?._id?.toString()) {
                                                    return true;
                                                }
                                                return company.disabled !== true;
                                            })
                                            .sort((a, b) =>
                                                a.companyName.localeCompare(b.companyName)
                                            )
                                            .map(company => (
                                                <CustomSelect.Option
                                                    disabled={company.disabled}
                                                    key={company._id}
                                                    value={company._id}
                                                    data-testid={`${obj.key}Select_option`}
                                                >
                                                    {company.companyName}
                                                </CustomSelect.Option>
                                            ))}
                                    </>
                                )}
                            </CustomSelect>
                        </Col>
                    )}
                    {obj.key == "region" && (
                        <Col>
                            {!hideTitle && (
                                <SelectTitle>
                                    {t("fields.pickupPointRegionGroup", {ns: "common"})}
                                </SelectTitle>
                            )}
                            <CustomSelect
                                style={{width: obj.width}}
                                mode={"multiple"}
                                value={
                                    regionGroupValue && regionGroupValue.length > 0
                                        ? regionGroupValue
                                        : ["all"]
                                }
                                onChange={onRegionGroupChange}
                                notFoundContent={t("filters.notEnoughData", {ns: "common"})}
                                loading={regionGroupLoading}
                                disabled={regionGroupLoading || disabled}
                                optionFilterProp="children"
                                data-testid={`${obj.key}Select`}
                                filterOption={filterOption}
                                filterSort={filterSort}
                            >
                                {regionGroupLoading ? (
                                    renderOptionLoading(obj.key)
                                ) : (
                                    <>
                                        {renderAllOption(obj.key)}
                                        {renderRegionGroupsByGrouping(regionGroupData, obj.key)}
                                    </>
                                )}
                            </CustomSelect>
                        </Col>
                    )}
                    {obj.key === "subcompany" && (
                        <Col>
                            {!hideTitle && (
                                <SelectTitle>{t("fields.subcompany", {ns: "common"})}</SelectTitle>
                            )}
                            <CustomSelect
                                style={{width: obj.width}}
                                mode={"multiple"}
                                data-testid={`${obj.key}Select`}
                                value={
                                    subCompanyValue && subCompanyValue.length > 0
                                        ? subCompanyValue
                                        : ["all"]
                                }
                                onChange={onSubCompanyChange}
                                notFoundContent={t("filters.notEnoughData", {ns: "common"})}
                                loading={subCompanyLoading}
                                disabled={
                                    subCompanyLoading ||
                                    (companyValue === "" && regionGroupValue[0] === "all") ||
                                    disabled
                                }
                                onClick={() =>
                                    companyValue === "" &&
                                    regionGroupValue[0] === "all" &&
                                    message.error(
                                        "Havuz kuryesine atama yaparken bölge grubu seçmelisiniz"
                                    )
                                }
                                optionFilterProp="children"
                                filterOption={filterOption}
                                filterSort={filterSort}
                            >
                                {subCompanyLoading ? (
                                    renderOptionLoading(obj.key)
                                ) : (
                                    <>
                                        {renderAllOption(obj.key)}
                                        {Object.values(subCompanyData).length > 0 &&
                                            arrayAlphabeticalSort(subCompanyData)
                                                .filter(sub => {
                                                    if (
                                                        Array.isArray(subCompanyValue) &&
                                                        subCompanyValue.includes(
                                                            sub?._id?.toString()
                                                        )
                                                    ) {
                                                        return true;
                                                    }
                                                    return sub.disabled !== true;
                                                })
                                                .map(sub => (
                                                    <Option
                                                        key={sub._id}
                                                        value={sub._id}
                                                        data-testid={`${obj.key}Select_option`}
                                                    >
                                                        {sub.name}
                                                    </Option>
                                                ))}
                                    </>
                                )}
                            </CustomSelect>
                        </Col>
                    )}
                    {obj.key === "deliveryPointRegionGroup" && (
                        <Col>
                            {!hideTitle && (
                                <SelectTitle>
                                    {t("fields.deliveryPointRegionGroup", {ns: "common"})}
                                </SelectTitle>
                            )}
                            <CustomSelect
                                style={{width: obj.width}}
                                mode={"multiple"}
                                value={
                                    deliveryPointRegionGroupsValues &&
                                    deliveryPointRegionGroupsValues.length > 0
                                        ? deliveryPointRegionGroupsValues
                                        : ["all"]
                                }
                                onChange={onDeliveryPointReqionGroupChange}
                                notFoundContent={t("filters.notEnoughData", {ns: "common"})}
                                loading={regionGroupLoading}
                                disabled={regionGroupLoading || disabled}
                                optionFilterProp="children"
                                data-testid={`${obj.key}Selecy`}
                                filterOption={filterOption}
                                filterSort={filterSort}
                            >
                                {regionGroupLoading ? (
                                    renderOptionLoading(obj.key)
                                ) : (
                                    <>
                                        {renderAllOption(obj.key)}
                                        {renderRegionGroupsByGrouping(regionGroupData)}
                                    </>
                                )}
                            </CustomSelect>
                        </Col>
                    )}
                    {obj.key === "slotCourier" && (
                        <Col>
                            <Checkbox
                                checked={slotCourierValue}
                                data-testid={`${obj.key}CheckBox`}
                                disabled={disabled}
                                onChange={e => {
                                    setSlotCourierValue(e.target.checked);
                                    setIsSlotCourierChanged(true);
                                }}
                            />
                            <SlotCourierTitle style={{color: disabled ? "gray" : "black"}}>
                                {t("slotCourier", {ns: "multipleSelect"})}
                            </SlotCourierTitle>
                        </Col>
                    )}
                </React.Fragment>
            ))}
        </SpaceField>
    ));
};
